import { Command, CommandRegistry, MenuContribution, MenuModelRegistry } from '@theia/core';
import {
    AbstractViewContribution,
    CommonMenus,
    FrontendApplication,
    FrontendApplicationContribution
} from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { TranslationsPanel } from './translations-panel';

const TranslationsCommand: Command = { id: 'lvgl-translations:open', label: 'Translations: Open' };

@injectable()
export class TranslationsPanelContribution
    extends AbstractViewContribution<TranslationsPanel>
    implements FrontendApplicationContribution, MenuContribution
{
    async onDidInitializeLayout(_app: FrontendApplication): Promise<void> {
        await this.openView({ activate: false, reveal: false });
    }

    constructor() {
        super({
            widgetId: TranslationsPanel.ID,
            widgetName: TranslationsPanel.LABEL,
            defaultWidgetOptions: { area: 'bottom' },
            toggleCommandId: TranslationsCommand.id
        });
    }

    override registerCommands(commands: CommandRegistry): void {
        commands.registerCommand(TranslationsCommand, {
            execute: async () => {
                const widget = await this.widgetManager.getOrCreateWidget<TranslationsPanel>(TranslationsPanel.ID);
                await this.shell.addWidget(widget, { area: 'bottom' });
                await this.shell.activateWidget(widget.id);
            }
        });
    }

    override registerMenus(menus: MenuModelRegistry): void {
        menus.registerMenuAction(CommonMenus.VIEW_VIEWS, {
            commandId: TranslationsCommand.id,
            label: TranslationsPanel.LABEL
        });
    }
}
